// extracted by mini-css-extract-plugin
export default {"textPreview":"TextPreview_textPreview__W+Yj2"};